export const SCI_FOOTER_KEYS = {
  privacyText: 'c8.self.check.in.footer.privacy',
  privacyTitle: 'c8.self.check.in.footer.privacy.title',
  termsText: 'c8.self.check.in.disclaimer',
  termsTitle: 'c8.self.check.in.footer.terms.title',
  changeLanguageTitle: 'c8.self.check.in.footer.select.your.language',
  urlXtime: 'c8.self.check.in.footer.xtime.url'
};

export const ST_FOOTER_KEYS = {
  privacyText: 'c8.status.tracker.footer.privacy',
  privacyTitle: 'c8.status.tracker.footer.privacy.title',
  termsText: 'c8.status.tracker.disclaimer',
  termsTitle: 'c8.status.tracker.footer.terms.title',
  changeLanguageTitle: 'c8.status.tracker.footer.select.your.language',
  urlXtime: 'c8.status.tracker.footer.xtime.url'
};

export const COMMON_I18N_PREFIX = 'c8.common';



// WEBPACK FOOTER //
// ./src/constants/localizationKeys.js